var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingSessionHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 4.75C14.4142 4.75 14.75 5.08579 14.75 5.5 14.75 5.8797 14.4678 6.19349 14.1018 6.24315L14 6.25H7.12C6.70579 6.25 6.37 5.91421 6.37 5.5 6.37 5.1203 6.65215 4.80651 7.01823 4.75685L7.12 4.75H14Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.25C13.4142 8.25 13.75 8.58579 13.75 9 13.75 9.3797 13.4678 9.69349 13.1018 9.74315L13 9.75H7.12C6.70579 9.75 6.37 9.41421 6.37 9 6.37 8.6203 6.65215 8.30651 7.01823 8.25685L7.12 8.25H13Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.75C8.41421 11.75 8.75 12.0858 8.75 12.5 8.75 12.8797 8.46785 13.1935 8.10177 13.2432L8 13.25H7.12C6.70579 13.25 6.37 12.9142 6.37 12.5 6.37 12.1203 6.65215 11.8065 7.01823 11.7568L7.12 11.75H8Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13-.75C16.1018-.75 18.6299 1.70602 18.7458 4.77944L18.75 5V9C18.75 9.41421 18.4142 9.75 18 9.75 17.6203 9.75 17.3065 9.46785 17.2568 9.10177L17.25 9V5C17.25 2.72183 15.4575.862314 13.2059.754901L13 .75H5C2.72183.75.862313 2.54251.754901 4.79408L.75 5V13C.75 15.2782 2.54251 17.1377 4.79408 17.2451L5 17.25H10C10.4142 17.25 10.75 17.5858 10.75 18 10.75 18.3797 10.4678 18.6935 10.1018 18.7432L10 18.75H5C1.89822 18.75-.629937 16.294-.745848 13.2206L-.75 13V5C-.75 1.89822 1.70602-.629937 4.77944-.745848L5-.75H13Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.258 11.789L15.1371 11.7053C14.0479 11.003 12.5932 11.1192 11.6325 12.0491 10.5086 13.1368 10.4793 14.9297 11.5671 16.0536L13.5642 18.0469C14.0152 18.4971 14.6266 18.75 15.264 18.75L15.4642 18.7411C16.0535 18.6838 16.5707 18.4397 16.9641 18.0465L18.9449 16.0618C20.0156 14.9556 20.0156 13.2125 18.9529 12.1145 17.9957 11.1255 16.4924 10.9841 15.3795 11.7057L15.258 11.789ZM17.8751 13.1577C18.3749 13.6741 18.3749 14.494 17.8751 15.0104L15.9031 16.9862C15.7559 17.1333 15.5614 17.2251 15.3538 17.2456L15.2273 17.2509C15.0239 17.25 14.7937 17.1548 14.6239 16.9852L12.6358 15.0011C12.1333 14.4818 12.1471 13.6385 12.6757 13.1269 13.1921 12.6271 14.012 12.6271 14.5284 13.1269L14.7309 13.3286C15.0235 13.6198 15.4965 13.6198 15.7891 13.3286L15.9991 13.1196C16.4855 12.6489 17.2525 12.6295 17.7685 13.0588L17.8751 13.1577Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31704 8C4.86877 8.00223 5.31422 8.4513 5.312 9 5.312 9.55072 4.86672 9.99779 4.316 10 3.76372 10.0022 3.31422 9.55628 3.312 9.004 3.30996 8.49116 3.6943 8.06695 4.19141 8.0072L4.31704 8Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31704 4.5C4.86877 4.50223 5.31422 4.9513 5.312 5.5 5.312 6.05072 4.86672 6.49779 4.316 6.5 3.76372 6.5022 3.31422 6.05628 3.312 5.504 3.30996 4.99117 3.6943 4.56695 4.19141 4.5072L4.31704 4.5Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31704 11.5C4.86877 11.5022 5.31422 11.9513 5.312 12.5 5.312 13.0507 4.86672 13.4978 4.316 13.5 3.76372 13.5022 3.31422 13.0563 3.312 12.504 3.30996 11.9912 3.6943 11.567 4.19141 11.5072L4.31704 11.5Z",
    stroke: "none",
    fill: "#323232"
  }))), /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    stroke: "none",
    width: 24,
    height: 24,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingSessionHeart);
export default __webpack_public_path__ + "static/media/training-session-heart.b602a905fbe0cf21e2464d9400e14137.svg";
export { ForwardRef as ReactComponent };